<template>
    <v-dialog v-model="dialog" persistent width="950">
      <v-card>
        <!-- Cabecera del formulario -->
        <v-card-title class="headline">
          <v-flex xs9>
            <v-icon>{{ form.id ? "edit" : "add" }}</v-icon>
            {{ form.id ? "Modificar dependencia" : "Crear dependencia" }}
          </v-flex>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
  
        <!-- Cuerpo del formulario --> 
        <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex md12 xs12>
                  <v-text-field
                    label="Nombre dependencia"
                    v-model="form.nombre_unidad"
                    :rules="$validate(['required'])"
                    required
                    outline
                  success
                  clearable
                  ></v-text-field>
                </v-flex>
                <v-flex md12 xs12>
                  <v-text-field
                    label="Sigla"
                    v-model="form.sigla"
                    :rules="$validate(['required'])"
                    required
                    outline
                  success
                  clearable
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                <v-select
                  :items="unidades"
                  item-value="id"
                  item-text="nombre_unidad"
                  name="nombre_unidad"
                  label="Seleccionar si el registro a crear depende de otra dirección,viceministerio,etc"
                  v-model="form.parent_id"
                  autofocus
                  outline
                  success
                  clearable
                ></v-select>
              </v-flex>
               
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <small class="error--text text-required"
              >* Los campos son obligatorios</small
            >
            <v-spacer></v-spacer>
            <v-btn @click.native="close()">
              <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
            </v-btn>
            <v-btn
              color="primary"
              type="submit"
              :loading="loading"
              :disabled="!valid"
            >
              <v-icon dark>check</v-icon> {{ $t("common.save") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
  
  export default {
    // Definición de mixins importados
    mixins: [validate],
    // Variables iniciales
    data() {
      return {
        dialog: false,
        form: {},
        cargos: [],
      unidades: [],
        valid: false,
        loading: false,
      };
    },
    async mounted() {
      this.$bus.$on("openDialogCrearActualizarUnidades",async (item) => {
        this.form = item;
        await this.cargarUnidades();
        this.dialog = true;
      });
    },
    methods: {
      close() {
        (this.form = {}), (this.loading = false);
        this.valid = false;
        this.$bus.$emit("closeDialogCrearActualizarUnidades");
        this.dialog = false;
      },
      async cargarUnidades() {
      try {
        let respuesta = await this.$service.graphql({
          query: `query{
                      runQuery(consulta:"select * from movilidad.unidad vl  where vl.id_estado=17 and vl.id_entidad =35 and vl.nombre_unidad not like '%UNIDAD%'"){
                        respuesta
                      }
                    }
                  `,
        });
        this.unidades = respuesta.runQuery.respuesta;
      } catch (error) {
        console.log(error);
      }
    },
      async save() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          let user = this.$storage.get("user");
          try {
              this.form.nombre_unidad=this.form.nombre_unidad.toUpperCase()
              this.form.sigla=this.form.sigla.toUpperCase()
            if (this.form.id) {
              //edito unidad
              let respuesta = await this.$service.graphql({
                query: `
                query{
                  runQuery(consulta:"select movilidad.fn_actualiza_unidad(${parseInt(
                    this.form.id
                  )} ,'${this.form.nombre_unidad}','${this.form.sigla}',${parseInt(this.form.parent_id)},${parseInt(user.id)})"){
                    respuesta
                  }
                }
              `,
              });
              console.log(`
              query{
                runQuery(consulta:"select movilidad.fn_actualiza_unidad(${parseInt(
                    this.form.id
                  )} ,'${this.form.nombre_unidad}','${this.form.sigla}',${parseInt(this.form.parent_id)},${parseInt(user.id)})"){
                    respuesta
                }
              }
            `);
              respuesta =
                respuesta.runQuery.respuesta[0].fn_actualiza_unidad.split("|");
              if (respuesta[0] == "1") {
                this.$message.success("Registro modificado exitosamente");
              } else {
                this.$message.warning(respuesta[1]);
              }
            } else {
              //creo nueva unidad
              let respuesta = await this.$service.graphql({
                query: `
                query{
                  runQuery(consulta:"select movilidad.fn_resgistra_unidad('${
                    this.form.nombre_unidad
                  }','${this.form.sigla}',${parseInt(this.form.parent_id)},${parseInt(user.id)})"){
                    respuesta
                  }
                }
              `,
              });
              respuesta =
                respuesta.runQuery.respuesta[0].fn_resgistra_unidad.split("|");
              if (respuesta[0] == "1") {
                this.$message.success("Registro creado exitosamente");
              } else {
                this.$message.warning(respuesta[1]);
              }
            }
          } catch (error) {
            console.log(error);
          }
          this.$message.success();
          this.loading = false;
          this.close();
        }
      },
    },
  };
  </script>
  
  <style>
  </style>
  


// WEBPACK FOOTER //
// src/components/admin/item_cargo_y_puesto/dialogs/CrearActualizarUnidades.vue